const ROUTE = process.env.REACT_APP_ROUTE_URL;

export const login = `${ROUTE}api/login`;
export const refreshToken = `${ROUTE}api/login/refresh`;